import { render, staticRenderFns } from "./QuizCompetitionView.vue?vue&type=template&id=609761ff"
import script from "./QuizCompetitionView.vue?vue&type=script&lang=js"
export * from "./QuizCompetitionView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports